import { getCalendarEventDetailsStore } from '../store/calendarEventDetailsStore';
import { mutator } from 'satcheljs';
import setCalendarEventDetails from '../actions/setCalendarEventDetails';

/**
 * Mutator that sets calendar event details
 */
mutator(setCalendarEventDetails, actionMessage => {
    const { event, eventDetailsFetched } = actionMessage;
    const store = getCalendarEventDetailsStore();
    store.calendarEvent = event;
    store.eventDetailsFetched = eventDetailsFetched;
});
